/*  API ENDPOINTS  */
export const ADDRESS_CREATE_ENDPOINT = 'addresses';
/*  ROUTES  */
